var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { useCreatorRewards, useUserVouchers, } from 'root/src/client/web/giveaway/hooks/useCreatorGiveaways';
import { useGiveawayApi } from 'root/src/client/web/giveaway/hooks/useGiveawayApi';
import { useCreatorDataApi } from 'root/src/client/logic/api/hooks/useCreatorDataApi';
import { GiveawayRewardStatus } from 'root/src/client/web/giveaway/giveaway.types';
import { VoucherStatus } from '@daredrop-com/rewards-api-contract';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import toast from 'react-hot-toast';
import RedeemedRewardsModal from 'root/src/client/web/giveaway/features/RedeemedRewardsModal/RedeemedRewardsModal';
export const useRedeemModal = () => {
    const vouchers = useUserVouchers();
    const rewards = useCreatorRewards();
    const giveawayApi = useGiveawayApi();
    const creatorDataApi = useCreatorDataApi();
    const modal = useModal();
    const [claimedRewards, setClaimedRewards] = useState([]);
    const totalVouchers = vouchers.length + claimedRewards.length;
    const onRedeem = (reward) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g;
        const voucher = vouchers[0];
        if (!voucher) {
            throw new Error('No vouchers left, please try again later');
        }
        const redeemedVoucher = yield giveawayApi.redeemVoucher({ rewardId: reward.fullId, voucherId: voucher.id });
        if (redeemedVoucher.error) {
            const message = (_b = (_a = redeemedVoucher === null || redeemedVoucher === void 0 ? void 0 : redeemedVoucher.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : 'Cannot redeem reward, please try again later';
            throw new Error(message);
        }
        const updatedClaimedRewards = [...claimedRewards, Object.assign(Object.assign({}, reward), { status: GiveawayRewardStatus.REDEEMED })];
        setClaimedRewards(updatedClaimedRewards);
        const [vouchersResponse, rewardsResponse,] = yield Promise.all([
            giveawayApi.fetchVouchers(VoucherStatus.Available),
            creatorDataApi.fetchRewards(),
            creatorDataApi.fetchGiveaways(),
        ]);
        const remainingVouchers = (_d = (_c = vouchersResponse === null || vouchersResponse === void 0 ? void 0 : vouchersResponse.body) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
        const remainingClaimableRewards = (_g = (_f = (_e = rewardsResponse === null || rewardsResponse === void 0 ? void 0 : rewardsResponse.body) === null || _e === void 0 ? void 0 : _e.filter(r => !r.isClaimed)) === null || _f === void 0 ? void 0 : _f.length) !== null && _g !== void 0 ? _g : 0;
        if (remainingVouchers === 0 || remainingClaimableRewards === 0) {
            modal.show(<RedeemedRewardsModal rewards={updatedClaimedRewards}/>);
        }
        toast.success('Reward redeemed successfully!');
    });
    return {
        onRedeem,
        vouchers,
        rewards: rewards.map((r) => {
            const claimed = claimedRewards.find(cr => cr.id === r.id);
            return claimed ? Object.assign(Object.assign({}, r), { status: GiveawayRewardStatus.REDEEMED }) : r;
        }),
        claimedRewards,
        totalVouchers,
    };
};
